import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, List, ListItem, Typography, ListItemText, Grid, Button } from '@material-ui/core';
import i18n from 'i18n-js';
import { useStyles, listTextStyles } from './InvoiceItems.styled';
import { Card } from 'components/UI';
import Loading from 'components/Loading';
import { useSelector } from 'react-redux';
import { formatAmount } from 'utils';
import { buildUrl } from 'utils';
import clsx from 'clsx';

const InvoicePayments = ({ id }) => {
  const history = useHistory();
  const classes = useStyles();
  const listClasses = listTextStyles();

  const { invoice, loading } = useSelector((state) => state.invoice);
  const { localeFormat } = useSelector((state) => state.organizations);

  const payments = invoice?.payments;

  const total_paid =
    invoice?.payments?.reduce((accumulator, payment) => accumulator + payment.charge_amount, 0) ||
    0;

  const paymentResume = [
    {
      label: i18n.t('invoice.paid_with_credits'),
      value: `$${formatAmount(invoice?.paid_credit)}`,
    },
    {
      label: i18n.t('invoice.total_preauth'),
      value: `$${formatAmount(invoice?.pre_auth)}`,
    },
    {
      label: i18n.t('invoice.total_paid'),
      value: `$${formatAmount(total_paid)}`,
      className: classes.total,
    },
  ];

  return (
    <Card
      title={
        <Grid container alignItems="center" justifyContent="space-between">
          <span>{i18n.t('invoice.payment')}</span>
          <Button
            type="button"
            variant="text"
            color="primary"
            disableFocusRipple={true}
            className={classes.button}
            data-cy="view-all-payments"
            onClick={() =>
              history.push({
                pathname: buildUrl('/payments'),
                state: {
                  invoice_id: id,
                  sort_field: 'modified_time',
                  sort_desc: true,
                },
              })
            }
          >
            {i18n.t('invoice.view_all')}
          </Button>
        </Grid>
      }
      headerActionType="vertical"
      datacy="invoice-payment-widget"
    >
      <Box className={classes.root}>
        {loading ? (
          <Box className={classes.loadingContainer}>
            <Loading />
          </Box>
        ) : (
          <>
            {payments?.length > 0 ? (
              <>
                <Box
                  style={{
                    height: '100%',
                    maxHeight: 'calc(100% - 52px)',
                    minHeight: 150,
                    overflowY: 'auto',
                  }}
                >
                  <List className={clsx(classes.list, classes.resume)}>
                    {paymentResume.map((info, index) => (
                      <ListItem key={index} className={classes.listItem}>
                        <ListItemText
                          primary={info.label}
                          secondary={
                            <Typography
                              variant="body2"
                              component="span"
                              color="textSecondary"
                              className={info.className}
                            >
                              {info.value}
                            </Typography>
                          }
                          classes={listClasses}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </>
            ) : (
              <Typography variant="h4">
                <Box fontSize={14}>{i18n.t('common.empty_list')}</Box>
              </Typography>
            )}
          </>
        )}
      </Box>
    </Card>
  );
};

export { InvoicePayments };
